import { createContext, useContext } from 'react';

/** IDs of the legacy (popup reducer) popups the current subtree is rendered inside, outermost first */
export const LegacyPopupAncestorsContext = createContext<readonly string[]>([]);

export const useLegacyPopupAncestors = (): readonly string[] => useContext(LegacyPopupAncestorsContext);
